import RocketBWSmall from './rocket_bw_small.mp4'
import RocketBWSmall2 from './rocket_bw_small_2.mp4'
import Rocket from './rocket.mp4'

export const Videos = {
  Rocket,
  RocketBWSmall,
  RocketBWSmall2,
}
